import AddActionButton from "../AddActionButton";
import CustomHandle from "../handles/CustomHandle";
import { useReactFlow } from "@xyflow/react";

const ExitNode = ({ id }) => {
  const reactFlowInstance = useReactFlow();

  // Find the edge connected to this exit node
  const edges = reactFlowInstance.getEdges();
  const connectedEdge = edges.find((edge) => edge.target === id);

  // If no edge is connected, don't render anything
  if (!connectedEdge) {
    return null;
  }

  return (
    <div
      style={{
        // Remove all default node styling to make container invisible
        background: "transparent",
        border: "none",
        padding: 0,
        margin: 0,
        boxShadow: "none",
        // Make container fit the button exactly (15x15px)
        width: "15px",
        height: "15px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* Hidden handle for edge connection - positioned at top */}
      <CustomHandle
        type="target"
        position="top"
        style={{
          opacity: 0, // Invisible
          pointerEvents: "none", // No interaction
          top: 0,
          left: "50%",
          transform: "translateX(-50%)",
        }}
      />

      {/* AddActionButton with all the menu logic */}
      <AddActionButton edgeId={connectedEdge.id} />
    </div>
  );
};

export default ExitNode;
